$(document).ready(function () {

    function animateCss(ele, animationName, callback) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        var $this = $(ele);

        $this.addClass('animated ' + animationName)
            .on(animationEnd, animateEnded);

        function animateEnded() {
            $this.off(animationEnd, animateEnded);
            $this.removeClass('animated ' + animationName);

            if (callback) {
                callback.call($this);
            }
        }
    }


    $('.hamburger, .mobile-menu .close-menu, .mobile-menu .overlay').on('click', function () {
        animateCss($('.mobile-menu .overlay').css('display', 'inline-block'), 'fadeIn');
        $('.mobile-menu').show();
        animateCss($('.mobile-menu ul'), 'slideInLeft');
    });

    $('.mobile-menu .close-menu, .mobile-menu .overlay').on('click', function () {
        animateCss($('.mobile-menu .overlay'), 'fadeOut', function () {
            $(this).hide();
        });
        animateCss($('.mobile-menu ul'), 'slideOutLeft', function () {
            $('.mobile-menu').hide();
        });
    });
});